module.exports = __webpack_public_path__ + "images/doodle.png?91eaafde0f938262e5fa00abf7cf6eb1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doodle.png
// module id = 287
// module chunks = 0